// react
import { 
    useState, 
    // useEffect 
} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { getIsSignedIn, getRole } from '../reducks/users/selectors'
import { signOut } from '../reducks/users/operations'
// mui
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Collapse from '@material-ui/core/Collapse'
import MailIcon from '@material-ui/icons/Mail'
import HistoryIcon from '@material-ui/icons/History'
import Person from '@material-ui/icons/Person'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import BuildIcon from '@material-ui/icons/Build'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'
import StorefrontIcon from '@material-ui/icons/Storefront'
import ImportContactsIcon from '@material-ui/icons/ImportContacts'
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents'
// firebase
// import { db } from '../firebase'

const MenuDrawer = (props) => {
    const dispatch = useDispatch()
    const selector = useSelector(state => state)
    const isSignedIn = getIsSignedIn(selector)
    const role = getRole(selector)
    const [open, setOpen] = useState(false)
    // const [filters, setFilters] = useState([])

    // ブランド毎のページリスト取得
    // useEffect(()=>{
    //     db.collection('brands')
    //       .orderBy('order','asc')
    //       .get()
    //       .then( snapshots => {
    //           const list = []
    //           snapshots.forEach(snapshot => {
    //               const brand = snapshot.data()
    //               list.push({label: brand.name, id: brand.id, value: `/product?brand=${brand.id}`})
    //           })
    //           setFilters(prevState => [...prevState, ...list])
    //       })
    // },[])
    
    return (
        <div key='right'>
            <SwipeableDrawer
                
                anchor='right' open={props.open}
                onClose={e=>props.onClose(e)} onOpen={e=>props.onClose(e)}
            >
                <div style={{width:'250px'}} onKeyDown={e=>props.onClose(e)}>
                    <List>
                        <ListItem key={3} button onClick={e=>{
                            dispatch(push('/news'))
                            props.onClose(e)
                        }}>
                            <ListItemIcon>
                                <ImportContactsIcon />
                            </ListItemIcon>
                            <ListItemText primary='ニュース' style={{fontFamily: "serif"}} />
                        </ListItem>
                        <ListItem key={2} button onClick={()=>setOpen(!open)}>
                            <ListItemIcon>
                                <StorefrontIcon />
                            </ListItemIcon>
                            <ListItemText primary='ブランド' />
                            {open ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem button onClick={(e)=>{
                                    dispatch(push('/brand/rzeus'))
                                    props.onClose(e)
                                }}>
                                    <ListItemText primary={'RZEUS'} />
                                </ListItem>
                                {/* {filters.map(filter => (
                                    <ListItem button key={filter.id} onClick={(e)=>{
                                        dispatch(push(filter.value))
                                        props.onClose(e)
                                    }}>
                                        <ListItemText primary={filter.label} />
                                    </ListItem>
                                ))} */}
                            </List>
                        </Collapse>
                        <ListItem key={4} button onClick={e=>{
                            dispatch(push('/magazine'))
                            props.onClose(e)
                        }}>
                            <ListItemIcon>
                                <ImportContactsIcon />
                            </ListItemIcon>
                            <ListItemText primary='MAGAZINE' />
                        </ListItem>
                        <ListItem key={5} button　onClick={e => {
                            dispatch(push('/contact'))
                            props.onClose(e)
                        }}>
                            <ListItemIcon>
                                <MailIcon />
                            </ListItemIcon>
                            <ListItemText primary='お問い合わせ' />
                        </ListItem>
                        <ListItem key={17} button　onClick={e => {
                            dispatch(push('/about'))
                            props.onClose(e)
                        }}>
                            <ListItemIcon>
                                <EmojiEventsIcon />
                            </ListItemIcon>
                            <ListItemText primary='T3とは' />
                        </ListItem>
                    </List>
                    <Divider />
                    <List onClick={e=>props.onClose(e)}>
                        {isSignedIn 
                        ? (
                        <>
                        <ListItem key={6} button onClick={() => dispatch(push('/mypage'))}>
                            <ListItemIcon>
                                <Person />
                            </ListItemIcon>
                            <ListItemText primary='マイページ' />
                        </ListItem>
                        <ListItem key={7} button onClick={() => dispatch(push('/order/history'))}>
                            <ListItemIcon>
                                <HistoryIcon />
                            </ListItemIcon>
                            <ListItemText primary='注文履歴' />
                        </ListItem>
                        <ListItem key={8} button onClick={() => dispatch(signOut())}>
                            <ListItemIcon>
                                <ExitToAppIcon />
                            </ListItemIcon>
                            <ListItemText primary='ログアウト' />
                        </ListItem>
                        </>
                        ) : (
                        <ListItem key={9} button onClick={() => dispatch(push('/signin'))}>
                            <ListItemIcon>
                                <ExitToAppIcon />
                            </ListItemIcon>
                            <ListItemText primary='ログイン' />
                        </ListItem>
                        )}
                    </List>
                    <Divider />
                        {role === 'admin' 
                        ? (
                    <List onClick={e=>props.onClose(e)}>
                        <ListItem key={10} button onClick={() => dispatch(push('/admin/product'))}>
                            <ListItemIcon>
                                <BuildIcon />
                            </ListItemIcon>
                            <ListItemText primary='商品管理' />
                        </ListItem>
                        <ListItem key={11} button onClick={() => dispatch(push('/admin/news'))}>
                            <ListItemIcon>
                                <BuildIcon />
                            </ListItemIcon>
                            <ListItemText primary='ニュース管理' />
                        </ListItem>
                        <ListItem key={12} button onClick={() => dispatch(push('/admin/magazine'))}>
                            <ListItemIcon>
                                <BuildIcon />
                            </ListItemIcon>
                            <ListItemText primary='マガジン管理' />
                        </ListItem>
                        <ListItem key={13} button onClick={() => dispatch(push('/admin/contact'))}>
                            <ListItemIcon>
                                <BuildIcon />
                            </ListItemIcon>
                            <ListItemText primary='お問い合わせ管理' />
                        </ListItem>
                        <ListItem key={14} button onClick={() => dispatch(push('/admin/order'))}>
                            <ListItemIcon>
                                <BuildIcon />
                            </ListItemIcon>
                            <ListItemText primary='注文管理' />
                        </ListItem>
                        <ListItem key={15} button onClick={() => dispatch(push('/admin/customer'))}>
                            <ListItemIcon>
                                <BuildIcon />
                            </ListItemIcon>
                            <ListItemText primary='顧客管理' />
                        </ListItem>
                        <ListItem key={16} button onClick={() => dispatch(push('/admin/sales'))}>
                            <ListItemIcon>
                                <AttachMoneyIcon />
                            </ListItemIcon>
                            <ListItemText primary='売上管理' />
                        </ListItem>
                    </List>
                        ) : ''}
                    
                    
                </div>
            </SwipeableDrawer>
        </div>
    )
}
export default MenuDrawer